module.exports = __webpack_public_path__ + "static/media/bitski.a48e1a54.svg";